import React, { useState } from 'react';
import { AccountingCategory } from '../../../../firebase/accountingFirestoreService';

interface DashboardFiltersProps {
  customDateRange: { start: string; end: string };
  setCustomDateRange: (range: { start: string; end: string }) => void;
  categories: AccountingCategory[];
  onApply: () => void;
}

const DashboardFilters: React.FC<DashboardFiltersProps> = ({
  customDateRange,
  setCustomDateRange,
  categories,
  onApply
}) => {
  const [selectedCategory, setSelectedCategory] = useState<string>('');

  return (
    <div className="">
  
    </div>
  );
};

export default DashboardFilters;